import { render } from "./PaymentHistories.vue?vue&type=template&id=29c8b380"
import script from "./PaymentHistories.vue?vue&type=script&lang=js"
export * from "./PaymentHistories.vue?vue&type=script&lang=js"
script.render = render

export default script